import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id FB93EA15-A9E8-432C-BC34-419DDCE44E3B
 * name format-columns
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-columns.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatColumnsIcon = createSvgIcon(<><path d="M3,3H11V5H3V3M13,3H21V5H13V3M3,7H11V9H3V7M13,7H21V9H13V7M3,11H11V13H3V11M13,11H21V13H13V11M3,15H11V17H3V15M13,15H21V17H13V15M3,19H11V21H3V19M13,19H21V21H13V19Z" /></>, 'FormatColumnsIcon');
export default FormatColumnsIcon